import apiRequest from './apiRequest';

export type MediaUploadPayload = {
  duration: number; // in seconds for a video
  extension: string; // should be lowercase and omit period
  mediaName: string; // user editable string, default to filename without extension
  resolution: string; // "1920x1080"
};

export type MediaUploadResponse = {
  mediaID: string;
  mediaUploadURL: string;
  thumbnailUploadURL: string;
};

export default async function postMediaUploadLink(payload: MediaUploadPayload) {
  const { data, error } = await apiRequest<MediaUploadResponse>(
    'mogen-orchestration',
    `/media/uploadLink`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );

  return { data, error };
}
